//#region streams.ts
/**
* This file simply re-exports the process's writeable streams
* The intention is to provide a boundary to mock in tests
* Anywhere in this package that writes to stdout/stderr,
* should use this module to get references to them.
*/
const stdout = process.stdout;
const stderr = process.stderr;

//#endregion
export { stderr, stdout };